import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagnifyingGlass2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMagnifyingGlass2"><Path d="M3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.8487 18.3729 14.551 17.3198 15.9057L21.4142 20L20 21.4142L15.9056 17.3199C14.5509 18.3729 12.8487 19 11 19C6.58172 19 3 15.4183 3 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagnifyingGlass2;
